import { PromoCode } from "../types";

export const promoCode: PromoCode[] = [
  {
    value: "XK3M9S",
    discount: 10,
  },
  {
    value: "DV8Q6L",
    discount: 20,
  },
];
